module.exports = __webpack_public_path__ + "img/9681621.svg";